import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRight14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.55035 3.47968L10.0807 7.01001L6.55035 10.5403L5.48969 9.47968L7.95935 7.01001L5.48969 4.54034L6.55035 3.47968Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRight14.displayName = 'ChevronRight14';
export default ChevronRight14;
